import React, {VideoHTMLAttributes} from "react";
import classNames from "classnames";
import {getVideoMime} from "../lib/getVideoMime";
import {useVideo} from "../model/useVideo";
import {VideoControl} from "../model/types";
import {VideoControls} from "../ui/VideoControls";
import styles from "./Video.module.scss";

export interface Props extends VideoHTMLAttributes<HTMLVideoElement> {
    sources: string[];
    uiControls?: boolean | VideoControl[] | undefined;
    className?: string;
    videoClassName?: string;
    controlsClassName?: string;
}

export const Video = (
    {
        sources,
        uiControls,
        className,
        videoClassName,
        controlsClassName,
        muted = true,
        autoPlay = false,
        ...props
    }: Props
) => {
    const {
        videoRef,
        isMuted,
        isPlaying,
        toggleMute,
        togglePlay,
        handlePlay,
        stopPlaying,
        handleVolumeChange,
    } = useVideo({
        autoPlay,
        muted,
    });

    if (!sources.length) return null;

    return (
        <div className={classNames(styles.root, className)}>
            <video
                ref={videoRef}
                {...props}
                muted={isMuted}
                autoPlay={autoPlay}
                onPlay={handlePlay}
                onPause={stopPlaying}
                onEnded={stopPlaying}
                onVolumeChange={handleVolumeChange}
                className={classNames(styles.video, videoClassName)}
                playsInline
            >
                {sources.map((src) => (
                    <source key={src} src={src} type={getVideoMime(src)} />
                ))}
            </video>
            <VideoControls
                controls={uiControls}
                muted={isMuted}
                playing={isPlaying}
                onToggleMute={toggleMute}
                onTogglePlay={togglePlay}
                className={controlsClassName}
            />
        </div>
    );
}
